import type { DashboardExerciseCard } from '../../../types/dashboard'

export type DashboardSessionParams = {
  id: string
  weekId: string
  subjectId: string
  exerciseType: string
  programId?: string
}

export type DashboardSessionRouteParams = DashboardSessionParams & {
  source: 'session'
}

export function buildSessionParams(
  exercise: DashboardExerciseCard,
): DashboardSessionParams {
  const sessionParams: DashboardSessionParams = {
    id: exercise.sessionId,
    weekId: exercise.weekId,
    subjectId: exercise.subjectId,
    exerciseType: exercise.exerciseType,
  }

  if (exercise.programId != null) {
    sessionParams.programId = exercise.programId
  }

  return sessionParams
}

export function buildSessionRouteParams(
  sessionParams: DashboardSessionParams,
): DashboardSessionRouteParams {
  return {
    ...sessionParams,
    source: 'session',
  }
}

export function shouldOpenExercisePreview(
  exercise: DashboardExerciseCard,
  effectiveWeek: number,
) {
  return (
    exercise.completedRepetitions === 0 &&
    effectiveWeek === 1 &&
    exercise.hasPreview
  )
}

export function getExerciseSubtitle(exercise: DashboardExerciseCard) {
  const parts = [
    exercise.subjectTitle,
    exercise.lengthMinutes != null ? `${exercise.lengthMinutes} min` : null,
  ].filter((part): part is string => part != null && part.length > 0)

  return parts.join(' • ')
}
